import { render, staticRenderFns } from "./MoreServiceDialog.vue?vue&type=template&id=21e55c0e&scoped=true&"
import script from "./MoreServiceDialog.vue?vue&type=script&lang=js&"
export * from "./MoreServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreServiceDialog.vue?vue&type=style&index=0&id=21e55c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e55c0e",
  null
  
)

export default component.exports